import { Swiper } from "swiper";

class Slider {
    constructor($el){
        this.$el = $el;
        this.$slider = this.$el.find('[data-slider="slider"]');

        this.slidesToShow = parseFloat(this.$el.data('slides-to-show')) || 1.4;
        this.noBreakpoints = this.$el.is('[data-no-breakpoints]');

        this.init();
    }

    init = () => {
        const options = {
    speed: 1000,
    loop: false,
    slidesPerView: 1,
    direction: 'horizontal',
    autoHeight: false,   // ← prevents exploding height
    watchOverflow: true,
};


        if (!this.noBreakpoints) {
            options.breakpoints = {
                990: { slidesPerView: 2.3 },
                1199: { slidesPerView: 4 },
            };
        }

        this.swiper = new Swiper(this.$slider[0], options);
    }
}

export default Slider;
